import PopoverContainer, {
  PopoverContainerProps,
} from '@/common/components/popover-container';
import { cn } from '@/shadcn-ui/utils';

interface GuidePopoverProps
  extends Pick<PopoverContainerProps, 'show' | 'triggerComponent'> {
  content?: string;
  className?: string;
}

/**
 * Wrapper component for the popover container with styling for the plan guide popover.
 */
export default function GuidePopover({
  show,
  triggerComponent,
  content,
  className,
}: GuidePopoverProps) {
  return (
    <PopoverContainer
      show={show}
      triggerComponent={triggerComponent}
      contents={<p className="body2 text-center text-flexcar-neutral100">{content}</p>}
      hasArrow={true}
      contentAlign="center"
      contentSide="top"
      sideOffset={8}
      className={cn(
        `w-[130px] rounded-[16px] bg-flexcar-neutral20 p-[16px] data-[state=closed]:duration-1000`,
        className
      )}
      arrowClassName="fill-flexcar-neutral20"
    />
  );
}
